import React from 'react';
import { ControlledCheckbox } from 'src/components';

const ControlledCheckboxRow = ({ ...props }) => {
  if (!props) return null;

  return (
    <div className="flex items-center">
      {props?.checkboxes?.map((checkbox, index) => (
        <ControlledCheckbox key={index} size="sm" {...checkbox} />
      ))}
    </div>
  );
};

export default ControlledCheckboxRow;
